"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var traversePath = function traversePath(_ref) {
  var parentId = _ref.parentId,
      path = _ref.path,
      data = _ref.data,
      _ref$results = _ref.results,
      results = _ref$results === void 0 ? {} : _ref$results;
  var finished = false;
  var obj = data;
  (path !== null && path !== void 0 ? path : []).forEach(function (crumb, index) {
    var _obj, _obj$crumb;

    var lastCrumb = index === path.length - 1;
    if (finished) return;

    if (((_obj = obj) === null || _obj === void 0 ? void 0 : (_obj$crumb = _obj[crumb]) === null || _obj$crumb === void 0 ? void 0 : _obj$crumb.constructor) === Array) {
      finished = true;
      obj[crumb].forEach(function (item) {
        if (lastCrumb) {
          var _item$awyesId;

          if (item !== null && item !== void 0 && (_item$awyesId = item.awyesId) !== null && _item$awyesId !== void 0 && _item$awyesId.length && item.awyesId !== parentId) {
            results[item.awyesId] = item;
          }
        } else {
          traversePath({
            parentId: parentId,
            path: path.slice(index + 1),
            data: item,
            results: results
          });
        }
      });
    } else {
      var _obj2, _obj3, _obj3$awyesId;

      obj = (_obj2 = obj) === null || _obj2 === void 0 ? void 0 : _obj2[crumb];

      if (lastCrumb && (_obj3 = obj) !== null && _obj3 !== void 0 && (_obj3$awyesId = _obj3.awyesId) !== null && _obj3$awyesId !== void 0 && _obj3$awyesId.length && obj.awyesId !== parentId) {
        results[obj.awyesId] = obj;
      }
    }
  });
  return results;
};

var _default = traversePath;
exports["default"] = _default;